"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _conferenceService, _handler;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserEventService = void 0;
const Service_1 = require("../Service");
/**
 * A service to handle browser window event
 * @ignore
 * @noInheritDoc
 */
class BrowserEventService extends Service_1.BaseConferenceService {
    /**
     * @ignore
     * @param sdk
     * @param conferenceService
     */
    constructor(sdk, conferenceService) {
        super(sdk);
        _conferenceService.set(this, void 0);
        _handler.set(this, void 0);
        __classPrivateFieldSet(this, _conferenceService, conferenceService);
    }
    /**
     * leave the conference after a delay
     */
    leaveAfterDelay(delay) {
        __classPrivateFieldGet(this, _conferenceService).leave({ keepAlive: true, reason: 'tabClosure' });
        this.sleep(delay);
    }
    /**
     * Blocks execution during delay ms
     */
    sleep(delay) {
        const start = new Date().getTime();
        while (new Date().getTime() < start + delay) { }
    }
    onConferenceJoined(e) {
        super.onConferenceJoined(e);
        if (__classPrivateFieldGet(this, _conferenceService).leaveConferenceOnBeforeUnload === true) {
            __classPrivateFieldSet(this, _handler, window.onbeforeunload);
            window.onbeforeunload = (event) => {
                const activeElement = event.target.activeElement;
                const isMailto = activeElement && activeElement.href && activeElement.href.startsWith('mailto:');
                const isTel = activeElement && activeElement.href && activeElement.href.startsWith('tel:');
                if (!isMailto && !isTel) {
                    this.leaveAfterDelay(1500);
                }
            };
        }
    }
    onConferenceLeft(e) {
        window.onbeforeunload = __classPrivateFieldGet(this, _handler) || null;
        super.onConferenceLeft(e);
    }
}
exports.BrowserEventService = BrowserEventService;
_conferenceService = new WeakMap(), _handler = new WeakMap();
